import { FormControl } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";

const DateTimePickerController = ({
  name,
  errors,
  required,
  label,
  disablePast = false,
  extraRules,
  control,
  disableMinutes,
  styles,
}) => {
  const formContext = useFormContext();
  const mcontrol = control || formContext;
  const formErrors = errors || formContext?.formState?.errors || {};
  return (
    <FormControl style={{ minWidth: 426, ...styles }}>
      <Controller
        name={name}
        control={mcontrol}
        rules={{
          required: {
            value: !!required,
            message: `${name} is required.`,
          },
          ...extraRules,
        }}
        render={({ field: { ref, ...rest } }) => (
          <DateTimePicker
            disablePast={disablePast}
            label={label}
            minutesStep={disableMinutes ? 60 : 1}
            slotProps={{
              textField: {
                variant: "outlined",
                margin: "normal",
                id: "date-picker-dialog",
              },
              actionBar: {
                "aria-label": "change date",
              },
            }}
            {...rest}
          />
        )}
      />
      <p style={{ color: "red" }}>{formErrors[name]?.message}</p>
    </FormControl>
  );
};

export default DateTimePickerController;
